// Polyfill for Buffer global
import { Buffer as BufferPolyfill } from 'buffer';

// Extend global interfaces to include Buffer
declare global {
  interface Window {
    Buffer: typeof BufferPolyfill;
  }

  var Buffer: typeof BufferPolyfill;
}

// Make Buffer available globally for older dependencies
window.Buffer = BufferPolyfill;
globalThis.Buffer = BufferPolyfill;
